import React, { useState, useRef, useCallback } from "react";

import { base, formatTimeToAMPM, formatTime } from "../../../constants/base";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import "./info.css";

const Info = ({ notificaion }) => {
  // SLIDER ARROWS
  const sliderRef = useRef();

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // SLIDER ARROWS

  const isCorporateSender = notificaion?.data?.sender?.role?.name === "corporate";
  const displayName = isCorporateSender
    ? notificaion?.data?.request?.employee?.name
    : notificaion?.data?.sender?.name;
  const displayAbout = isCorporateSender
    ? notificaion?.data?.request?.employee?.about
    : notificaion?.data?.sender?.about;
  const displayImage = isCorporateSender
    ? notificaion?.data?.request?.employee?.images?.[0]?.path
    : notificaion?.data?.sender?.images?.[0]?.path;

  const reviews = notificaion?.data?.sender_feedback;
  const schedule = notificaion?.data?.request?.schedule;

  return (
    <div className="request-info-card">
      <div className="request-info-header">
        <div className="request-info-avatar">
          {displayImage ? (
            <img src={base.imageUrl + displayImage} alt="" />
          ) : (
            <i className="fa-solid fa-user"></i>
          )}
        </div>
        <h1>{displayName}</h1>
        {notificaion?.data?.sender?.address && (
          <span className="request-info-location">
            <i className="fas fa-map-marker-alt"></i>{" "}
            {notificaion?.data?.sender?.address?.address || "No location set yet."}
          </span>
        )}
      </div>

      <div className="request-info-body">
        {displayAbout && (
          <div className="request-info-section">
            <h2>About</h2>
            <p>{displayAbout}</p>
          </div>
        )}

        <div className="request-info-section">
          <div className="request-info-section-heading">
            <h2>User Reviews</h2>
            {reviews?.length > 0 && (
              <div className="request-info-slider-arrows">
                <i
                  className={`fa-solid fa-arrow-left ${isBeginning ? "is-disabled" : ""}`}
                  onClick={handlePrev}
                ></i>
                <i
                  className={`fa-solid fa-arrow-right ${isEnd ? "is-disabled" : ""}`}
                  onClick={handleNext}
                ></i>
              </div>
            )}
          </div>

          {reviews?.length > 0 ? (
            <Swiper
              slidesPerView={"4"}
              spaceBetween={12}
              navigation={false}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              modules={[Navigation, Autoplay]}
              onSlideChange={handleSlideChange}
              className="mySwiper"
              ref={sliderRef}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 12 },
                425: { slidesPerView: 1, spaceBetween: 12 },
                768: { slidesPerView: 2.3, spaceBetween: 12 },
                780: { slidesPerView: 2.3, spaceBetween: 12 },
                1280: { slidesPerView: 2.3, spaceBetween: 12 },
              }}
            >
              {reviews.map((feedback, index) => (
                <SwiperSlide key={index}>
                  <div className="request-info-review-card">
                    <div className="star-rating">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`star ${star <= (feedback?.stars || 0) ? "yellow-star" : "grey-star"
                            }`}
                        >
                          <i className="fa-solid fa-star"></i>
                        </span>
                      ))}
                      <span className="star">({feedback?.stars}.0)</span>
                    </div>
                    <p>"{feedback?.message}"</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <p className="request-info-no-reviews">This user has no reviews yet.</p>
          )}
        </div>

        <div className="request-info-chips">
          {notificaion?.data?.request?.service?.name && (
            <span className="request-info-chip">
              <i className="fa-solid fa-briefcase"></i>
              {notificaion?.data?.request?.service?.name}
            </span>
          )}

          {schedule?.day && (
            <span className="request-info-chip">
              <i className="fa-regular fa-clock"></i>
              {schedule.day}:{" "}
              {schedule?.start_time && formatTimeToAMPM(schedule.start_time)} To{" "}
              {schedule?.end_time && formatTimeToAMPM(schedule.end_time)}
            </span>
          )}

          {notificaion?.data?.request?.created_at && (
            <span className="request-info-chip">
              <i className="fa-solid fa-calendar-check"></i>
              Requested on {formatTime(notificaion?.data?.request?.created_at)}
            </span>
          )}
        </div>

        {notificaion?.data?.request?.reason && (
          <div className="request-info-section">
            <h2>Reason</h2>
            <p>{notificaion?.data?.request?.reason}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Info;
